export enum KinderGardenType {
  Public = 'Public',
  Private = 'Private'
}
